import { LinkCondition } from "./link-tree.types";

export const evaluateCondition = (condition: LinkCondition | undefined): boolean => {
  if (condition === undefined) return true;
  if (typeof condition === 'boolean') return condition;
  if (typeof condition === 'function') return condition();
  return true;
}; 